import React__default, { useRef } from 'react';
import RcSlider from 'rc-slider/lib/Slider';
import PropTypes from 'prop-types';
import { I as Icon } from './index-11bc5ac3.js';
import { B as Button } from './Button-a16585e5.js';
import './_commonjsHelpers-17042db9.js';
import './_rollupPluginBabelHelpers-e71b1aad.js';
import './utilsHelpers-e4b21f4b.js';
import './PropTypes-e1e509ba.js';
import 'moment';

var Slider = function Slider(_ref) {
  var marks = _ref.marks,
    _onChange = _ref.onChange,
    min = _ref.min,
    max = _ref.max,
    disabled = _ref.disabled,
    options = _ref.options,
    selectedOption = _ref.selectedOption,
    showButtons = _ref.showButtons;
  var value = useRef(min);
  var sliderColor = '#c2c2c2';
  var disabledColor = '#E9E9E9';
  var dotStyle = {
    width: '2px',
    height: '10px',
    backgroundColor: disabled ? disabledColor : sliderColor,
    border: 0,
    marginLeft: 0
  };
  var handleStyle = {
    height: 20,
    width: 20,
    marginLeft: -10,
    marginTop: -10,
    backgroundColor: disabled ? disabledColor : '#B3A157',
    border: 0
  };
  var railStyle = {
    backgroundColor: disabled ? disabledColor : sliderColor,
    height: 2
  };
  var handleOnChangeButton = function handleOnChangeButton(number) {
    var index = options.findIndex(function (e) {
      return e.value === selectedOption;
    });
    if (options[index + number]) {
      value.current = options[index + number].slider.step;
      _onChange(value.current);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-slider-main-wrapper"
  }, showButtons ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-slider-container"
  }, /*#__PURE__*/React__default.createElement(Button, {
    secondary: true,
    className: "bf-slider-btn-left",
    onClick: function onClick() {
      return handleOnChangeButton(-1);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-sign-minus"
  })), /*#__PURE__*/React__default.createElement(RcSlider, {
    marks: marks,
    value: value.current,
    included: false,
    step: null,
    onChange: function onChange(number) {
      _onChange(number);
      value.current = number;
    },
    min: min,
    max: max,
    dotStyle: dotStyle,
    railStyle: railStyle,
    handleStyle: handleStyle,
    disabled: disabled
  }), /*#__PURE__*/React__default.createElement(Button, {
    secondary: true,
    className: "bf-slider-btn-right",
    onClick: function onClick() {
      return handleOnChangeButton(1);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-sign-plus"
  }))) : /*#__PURE__*/React__default.createElement(RcSlider, {
    marks: marks,
    included: false,
    step: null,
    onChange: _onChange,
    min: min,
    max: max,
    dotStyle: dotStyle,
    railStyle: railStyle,
    handleStyle: handleStyle,
    disabled: disabled
  }));
};
Slider.defaultProps = {
  marks: {},
  options: [],
  showButtons: false,
  selectedOption: ''
};
Slider.propTypes = {
  marks: PropTypes.objectOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  selectedOption: PropTypes.string,
  showButtons: PropTypes.bool
};

export default Slider;
//# sourceMappingURL=Slider.js.map
